<template>
    <b-modal
        :id="`modal-form-${modalId}`"
        ref="modal"
        :title="modalTitle"
        size="md"
        cancel-variant="light"
        ok-variant="primary"
        :cancel-title="$t('cancel')"
        :ok-title="$t('next')"
        :busy="submitting"
        static
        @ok.prevent="handleSubmit()"
        @show="resetData()"
        @hidden="resetData()"
    >
        <b-overlay :show="submitting" opacity="0" class="h-100">
            <b-form @submit.prevent>

                <FormValidator :label="$t('advertiser')" form-group v-slot="slotProps" :validator="$v.advertiserId">
                    <Multiselect
                        :show-selected="true"
                        :asynchronous="true"
                        :fetch-options-function="fetchAdvertisers"
                        :parse-options-function="parseAdvertisers"
                        :placeholder="$t('selectField.placeholder')"
                        track-by="id"
                        label="optionName"
                        select-label=""
                        :state="slotProps.state"
                        :disabled="submitting"
                        :track-by-label="$t('id')"
                        @inputTrackBy="advertiserId = $event"
                    />
                </FormValidator>

                <FormValidator :validator="$v.form.name" form-group v-slot="slotProps" :label="$t('shopName')" :attribute="$t('name')">
                    <b-form-input v-model="form.name" :disabled="submitting" :state="slotProps.state" />
                </FormValidator>

            </b-form>
        </b-overlay>
    </b-modal>
</template>



<script>
    import { required } from 'vuelidate/lib/validators';
    import ModalFormMixin from '@/mixins/modalFormMixin';
    import FormValidator from '@/components/common/FormValidator.vue';
    import Multiselect from '@/components/common/Multiselect.vue';
    import userService from '@/services/userService';
    import Role from '@/Role';

    export default {
        name: 'ModalAddCampaign',
        mixins: [ModalFormMixin],
        components: {
            FormValidator,
            Multiselect,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                modalId: 'campaigns-advertiser-campaigns',
                form: {
                    name: '',
                    description: '',
                    conditionDescription: '',
                    nameOnBuybox: '',
                },
                advertiserId: null,
            };
        },
        computed: {
            createAction() {
                return this.$req('campaigns/AdvertiserCampaigns').post;
            },
            formValidations() {
                return {
                    form: {
                        name: { required },
                    },
                    advertiserId: { required },
                };
            },
            modalTitle() {
                return this.$t('addCampaign');
            },
            apiParams() {
                return {
                    requestParams: this.form,
                    urlParams: { userId: this.advertiserId },
                };
            },
        },
        watch: {
            'form.name': {
                handler() {
                    this.form.nameOnBuybox = this.form.name;
                },
            },
        },
        methods: {
            getDataStructure(data) {
                return { name: data.name };
            },
            refreshData() {
                this.parentComponent.fetchData();
            },
            afterSuccess(data) {
                this.advertiserId = null;
                this.refreshData();
                this.$router.push({ name: 'CampaignsDetailsTabIndex', params: { id: data.id, tab: 'settings', parentUrl: this.$route.fullPath } });
            },
            fetchAdvertisers({ search }) {
                const requestParams = { search, roles: [Role.ADVERTISER] };
                return userService.getUsers({ requestParams });
            },
            parseAdvertisers(data) {
                return (data?.items || []).map(item => ({ ...item, optionName: `${item.profile.firstName} ${item.profile.lastName} (${item.username})` }));
            },
            afterInitFormValues() {
                this.advertiserId = null;
            },
        },
    };
</script>
